import { UserListDTO } from '../user/user-list.dto';

export class ProductTestAnswerListDTO {

    id: string;

    successful: boolean;

    note: string;

    ignore: boolean;

    reason: string;

    user: UserListDTO;

}
